<template>
  <h1>Certificaciones</h1>
  <p class="mt-2 text-800 font-medium">
    Lista de cartas y certificaciones disponibles.
  </p>
  <div class="card p-fluid pt-3">
    <DataTable
      class="tabla"
      :value="certifications"
      dataKey="id"
      paginator
      :rows="5"
      :rowsPerPageOptions="[5, 10]"
      tableStyle="min-width: 50rem"
    >
      <Column header="Nombre" field="name">
        <template #body="{ data, field }">
          <span class="text-600 font-medium">{{ data[field] }}</span> </template
        >f
      </Column>
      <Column header="Descripción" field="description">
        <template #body="{ data, field }">
          <span class="text-600 font-medium">{{ data[field] }}</span>
        </template>
      </Column>
      <Column header="Acciones">
        <template #body="{ data }">
          <ConfirmPopup></ConfirmPopup>
          <Button
            icon="pi pi-download"
            class="action-btn view p-button-sm px-2"
            v-tooltip.bottom="'Generar documento'"
            @click="onGenerate($event, data.id)"
          ></Button>
        </template>
      </Column>
      <template #loading> Cargando... </template>
    </DataTable>
  </div>
</template>
<script setup lang="ts">
  import { onMounted, ref } from 'vue'
  import {
    generateCertification,
    getCertifications,
  } from '../services/CertificationService'
  import { Certification } from '../models/Certification'
  import useLoading from '@/store/load'
  import { useConfirm } from 'primevue/useconfirm'
  import useNotifications from '@/store/notification'
  import { useUserStore } from '@/store/user'
  import { storeToRefs } from 'pinia'
  const { user } = storeToRefs(useUserStore())

  const confirm = useConfirm()
  const loadingStore = useLoading()
  const notificationStore = useNotifications()
  const certifications = ref<Certification[]>([])

  const onGenerate = (event: any, letterId: string) => {
    if (letterId.includes('retenciones')) {
      window.open(letterId, '_blank')
      notificationStore.addSuccesNotification({
        detail: `200`,
        severity: 'success',
        summary: `Certificación generada exitosamente.`,
      })
    } else {
      confirm.require({
        target: event.currentTarget,
        message:
          'La generación del documento sera notificada. ¿Deseas continuar?',
        icon: 'pi pi-exclamation-info',
        acceptClass: 'p-button p-button-sm',
        rejectClass: 'p-button-danger text-200 font-light p-button-sm',
        acceptLabel: 'Continuar',
        rejectLabel: 'Cancelar',
        accept: async () => {
          loadingStore.setLoadingState()
          const response = await generateCertification({
            certificationId: letterId,
            employeeId: user.value?.employeeId || '',
          })
          loadingStore.dismissLoadingState()
          const url = window.URL.createObjectURL(response)
          window.open(url, '_blank')
          notificationStore.addSuccesNotification({
            detail: `200`,
            severity: 'success',
            summary: `Certificación generada exitosamente.`,
          })
        },
        reject: () => {},
      })
    }
  }

  onMounted(async () => {
    loadingStore.setLoadingState()
    certifications.value = await getCertifications(user.value?.employeeId || '')
    loadingStore.dismissLoadingState()
  })
</script>
<style scoped>
  .action-btn {
    height: 20px;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .tabla {
    margin-top: 1rem;
    box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.1),
      0px 4px 5px -2px rgba(0, 0, 0, 0.12),
      0px 10px 15px -5px rgba(0, 0, 0, 0.2);
    border-radius: 16px;
    width: 90%;
  }

  :deep(.p-column-title) {
    font-size: 14px;
  }

  :deep(.p-datatable-tbody) {
    font-size: 14px;
  }

  :deep(.p-paginator) {
    display: flex;
    align-items: center;
    justify-content: end;
    flex-wrap: wrap;
    font-size: 14px;
  }
</style>
